import { SecondaryButton } from "components/ui/secondary-button";
import * as React from "react";
import { disableAdvancedMode } from "util/browser";
import { CommunityAdvancedDetail } from "./advanced/advanced-detail";
import { CommunityMergePanel, MergeCandidate } from "./advanced/community-merge";

interface CommunityAdvancedViewProps {
    community: MergeCandidate;
}

export const CommunityAdvancedView: React.FC<CommunityAdvancedViewProps> = props => {
    const { community } = props;
    return (
        <div className="flex-grow">
            <div className="space-y-4">
                <CommunityAdvancedDetail communityId={community.id} />
                <CommunityMergePanel key={community.id} community={community} />
                <SecondaryButton onClick={disableAdvancedMode}>
                    Hide advanced tab
                </SecondaryButton>
            </div>
        </div>
    );
};
